import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import oktaAuth from '../modules/auth/OktaAuth';


// Define a service using a base URL and expected endpoints
export const subscriptionsApi = createApi({
    reducerPath: 'subscriptionsApi',
    //tagTypes: ['Customers'],
    baseQuery: fetchBaseQuery({
        baseUrl: `https://innovation-portal-data-security.azure-api.net/cx-portal/`,
        prepareHeaders: (headers) => {
            // , { getState }
            // const token = (getState() as RootState).auth.token;
            const idToken = oktaAuth.getIdToken();
            // If we have a token set in state, let's assume that we should be passing it.
            if (idToken) {
                headers.set('authorization', `Bearer ${idToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        getSubscripitons: builder.query({
            query: ()=> 'workspan'
        })
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetSubscripitonsQuery } = subscriptionsApi;
